// extracted by mini-css-extract-plugin
export default {"StatsList":"styles_StatsList__RR4B+"};